import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('approval_condition'),
    doneButton: defineMessage('done'),
    description: defineMessage('select_whether_all_appr__complete_this_step_url'),
    learnMore: defineMessage('learn_more'),
    stepTypeDefaultTitle: defineMessage('all'),
    stepTypeDefaultDescription: defineMessage('all_assigned_approvers_must_approve_this_request'),
    stepTypeAnyOfTitle: defineMessage('any_of'),
    stepTypeAnyOfDescription: defineMessage('only_the_specified_numb_to_approve_this_request'),
    stepTypeAnyOfDescriptionImportantLabel: defineMessage('important'),
    stepTypeAnyOfDescriptionImportantNote: defineMessage('if_you_dont_set_the_req_rs_will_need_to_approve'),
    numberOfApproversLabel: defineMessage('number_of_approvers'),
};
